import { memo, PropsWithChildren } from 'react'
import { styled } from 'styled-components'
import { AppBar } from '../appbar'
import { Footer } from '../footer'

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const Main = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const Layout = memo(({ children }: PropsWithChildren) => {
  return (
    <Root>
      <AppBar />
      <Main>{children}</Main>
      <Footer />
    </Root>
  )
})
Layout.displayName = 'Layout'
